
export default [

  { Id: [1, 2, 11000], SubjectCode: 'TOAN' },
  { Id: [5], SubjectCode: 'TIENGVIET' },
  { Id: [30, 11005], SubjectCode: 'NGUVAN' },
  { Id: [45, 131], SubjectCode: 'TIENGANH' },
  { Id: [10, 11010, 12502], SubjectCode: 'VATLY' },
  { Id: [15, 11010, 12502], SubjectCode: 'HOAHOC' },
  { Id: [20, 11010, 12502], SubjectCode: 'SINHHOC' },
  { Id: [35, 95, 12504], SubjectCode: 'LICHSU' },
  { Id: [40, 95, 12504], SubjectCode: 'DIALY' },
  { Id: [65, 11020], SubjectCode: 'GDCD' },
  { Id: [133, 55], SubjectCode: 'TIENGPHAP' },
  { Id: [60, 134], SubjectCode: 'TIENGTQ' },
  { Id: [50, 132], SubjectCode: 'TIENGNGA' },
  // { Id: [], SubjectCode: 'TIENGNHAT' },
  { Id: [], SubjectCode: 'KHTN' },
  { Id: [80], SubjectCode: 'DAODUC' },
  { Id: [85], SubjectCode: 'TNXH' },
  { Id: [120], SubjectCode: 'THUCONG' },
  { Id: [100], SubjectCode: 'AMNHAC' },
  { Id: [105], SubjectCode: 'MITHUAT' },
  { Id: [75, 130], SubjectCode: 'THEDUC' },
  { Id: [110, 115, 145, 11030], SubjectCode: 'TINHOC' },
  { Id: [70, 11025], SubjectCode: 'CONGNGHE' },
  { Id: [125], SubjectCode: 'KITHUAT' },
  { Id: [90], SubjectCode: 'KHOAHOC' },
  { Id: [], SubjectCode: 'LSDL' },
  { Id: [135], SubjectCode: 'GDQP' },
  { Id: [128], SubjectCode: 'HDTN' },
  { Id: [127], SubjectCode: 'GDTC' },
  { Id: [12508], SubjectCode: 'NDGDDP' },
  { Id: [12509], SubjectCode: 'HDTNHN' },
  { Id: [999999], SubjectCode: 'KHAC' }
  // { Id: , SubjectCode: 'TIENGNHAT'},

]
